/**
 * Lite funnel translations
 * Separated for maintainability — covers /lite email capture, completion view, recap, and HR request
 */

export const liteTranslations = {
  en: {
    // Completion header
    lite_completion_title: "Great job!",
    lite_completion_title_name: "Great job, {{name}}!",
    lite_completion_subtitle: "Here's a summary of your first session and what's next.",

    // Conversation completion card (in ActivityApp)
    lite_conversation_done_title: "You just had your first lesson!",
    lite_conversation_done_message: "Your personalized learning plan is ready. Unlock 20 tailored activities designed just for you.",
    lite_unlock_plan: "Unlock my learning plan",

    // Recap sections
    lite_recap_scenario: "Scenario practiced",
    lite_recap_skills: "Skills practiced",
    lite_recap_focus: "Focus areas",
    lite_recap_cadence: "Recommended weekly cadence",
    lite_recap_next: "Your next activities",

    // HR request section
    lite_hr_title: "Ask your employer to support your workplace language development",
    lite_hr_option_a: "Send directly to your HR team",
    lite_hr_email_placeholder: "HR email address",
    lite_hr_send: "Send",
    lite_hr_sending: "Sending...",
    lite_hr_sent: "Sent!",
    lite_hr_retry: "Retry",
    lite_hr_sent_message: "Request sent to your HR team.",
    lite_hr_error_message: "Something went wrong. Please try again.",
    lite_hr_or: "or",
    lite_hr_option_b: "Open a pre-filled email to forward",

    // Email modal
    email_work_hint: "We recommend using your work email for a better experience.",
  },
  fr: {
    // Completion header
    lite_completion_title: "Bravo !",
    lite_completion_title_name: "Bravo, {{name}} !",
    lite_completion_subtitle: "Voici un résumé de votre première session et les prochaines étapes.",

    // Conversation completion card (in ActivityApp)
    lite_conversation_done_title: "Vous venez de compléter votre première leçon !",
    lite_conversation_done_message: "Votre plan d'apprentissage personnalisé est prêt. Débloquez 20 activités conçues pour vous.",
    lite_unlock_plan: "Débloquer mon plan d'apprentissage",

    // Recap sections
    lite_recap_scenario: "Scénario pratiqué",
    lite_recap_skills: "Compétences pratiquées",
    lite_recap_focus: "Axes d'amélioration",
    lite_recap_cadence: "Cadence hebdomadaire recommandée",
    lite_recap_next: "Vos prochaines activités",

    // HR request section
    lite_hr_title: "Demandez à votre employeur de soutenir le développement de vos compétences linguistiques au travail",
    lite_hr_option_a: "Envoyer directement au courriel des RH",
    lite_hr_email_placeholder: "Adresse courriel des RH",
    lite_hr_send: "Envoyer",
    lite_hr_sending: "Envoi...",
    lite_hr_sent: "Envoyé !",
    lite_hr_retry: "Réessayer",
    lite_hr_sent_message: "Demande envoyée à votre équipe RH.",
    lite_hr_error_message: "Un problème est survenu. Veuillez réessayer.",
    lite_hr_or: "ou",
    lite_hr_option_b: "Ouvrir un courriel prérempli à transférer",

    // Email modal
    email_work_hint: "Nous recommandons d'utiliser votre courriel professionnel.",
  },
  es: {
    // Completion header
    lite_completion_title: "Buen trabajo!",
    lite_completion_title_name: "Buen trabajo, {{name}}!",
    lite_completion_subtitle: "Aquí tienes un resumen de tu primera sesión y lo que sigue.",

    // Conversation completion card (in ActivityApp)
    lite_conversation_done_title: "Acabas de completar tu primera lección!",
    lite_conversation_done_message: "Tu plan de aprendizaje personalizado está listo. Desbloquea 20 actividades diseñadas para ti.",
    lite_unlock_plan: "Desbloquear mi plan de aprendizaje",

    // Recap sections
    lite_recap_scenario: "Escenario practicado",
    lite_recap_skills: "Habilidades practicadas",
    lite_recap_focus: "Áreas de enfoque",
    lite_recap_cadence: "Cadencia semanal recomendada",
    lite_recap_next: "Tus próximas actividades",

    // HR request section
    lite_hr_title: "Pide a tu empleador que apoye tu desarrollo lingüístico laboral",
    lite_hr_option_a: "Enviar directamente al correo de RR.HH.",
    lite_hr_email_placeholder: "Correo electrónico de RR.HH.",
    lite_hr_send: "Enviar",
    lite_hr_sending: "Enviando...",
    lite_hr_sent: "Enviado!",
    lite_hr_retry: "Reintentar",
    lite_hr_sent_message: "Solicitud enviada a tu equipo de RR.HH.",
    lite_hr_error_message: "Algo salió mal. Por favor, inténtalo de nuevo.",
    lite_hr_or: "o",
    lite_hr_option_b: "Abrir un correo prellenado para reenviar",

    // Email modal
    email_work_hint: "Recomendamos usar tu correo de trabajo para una mejor experiencia.",
  },
};
